import React from "react";


const LoginInAdmin = (props) => {

  return (
    <div>
      <div className="flex items-center justify-center h-[100vh]">
        <form
          onSubmit={props.handleEmailandPassword}
          className="bg-white rounded-lg shadow-md p-6 w-full max-w-lg"
        >
          <h1 className="text-2xl font-bold text-center">Sign In</h1>

          {/* Email Input */}
          <div>
            <label htmlFor="email" className="block text-gray-700 font-medium mb-2">
              Email
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter your email"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={props.email}
              onChange={(e) => props.setEmail(e.target.value)}
            />
          </div>

          {/* Password Input */}
          <div className="mt-4">
            <label htmlFor="password" className="block text-gray-700 font-medium mb-2">
              Password
            </label>
            <input
              type="password"
              id="password"
              placeholder="Enter your password"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={props.password}
              onChange={(e) => props.setPassword(e.target.value)}
            />
          </div>

          {/* Error Display */}
          {props.error && <p className="text-red-500 text-sm mt-2">{props.error}</p>}

          {/* Login Button */}
          <button
            type="submit"
            className="bg-blue-500 mt-7 text-white w-full py-2 rounded-md hover:bg-blue-700 transition duration-300"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginInAdmin;
